import React, { useCallback, useEffect, useState } from "react";
import PropTypes from "prop-types";
import withRouter from "../../components/Common/withRouter";

// import Components
import Sidebar from "./Sidebar";
import Header from "./Header";
import Footer from "./Footer";
import RightSidebar from "../../components/Common/RightSideBar";
//redux
import { useDispatch, useSelector } from "react-redux";
import {
  changeLayout,
  changeSidebarTheme,
  changeSidebarType,
  changeTopbarTheme,
  changeLayoutWidth,
  showRightSidebarAction,
  updateVisibility
} from "../../store/actions";
import Chat from "../../components/Common/Chat";
import TrialInfoBubble from "../../components/Common/TrialInfoBubble";
import Intercom from "@intercom/messenger-js-sdk";

const Layout = (props) => {
  const dispatch = useDispatch();

  const [user, setUser] = useState(undefined);

  const { layoutWidth, leftSideBarType, topbarTheme, showRightSidebar, leftSideBarTheme, subscription_trialing } = useSelector((state) => ({
    show: state.Modal.show,
    thestate: state,
    leftSideBarType: state.Layout.leftSideBarType,
    layoutWidth: state.Layout.layoutWidth,
    topbarTheme: state.Layout.topbarTheme,
    showRightSidebar: state.Layout.showRightSidebar,
    leftSideBarTheme: state.Layout.leftSideBarTheme,
    subscription_trialing: state.subscription.subscription?.status === "trialing"
  }));

  useEffect(() => {
    var user_data_string = localStorage.getItem("user");

    if (!user_data_string) return;

    var user = JSON.parse(user_data_string);
    setUser(user);
  }, []);

  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  const handleButtonClick = () => {
    dispatch(updateVisibility(false));
  };

  //hides right sidebar on body click
  const hideRightbar = useCallback(
    (event) => {
      var rightbar = document.getElementById("right-bar");
      //if clicked in inside right bar, then do nothing
      if (rightbar && rightbar.contains(event.target)) {
        return;
      } else {
        //if clicked in outside of rightbar then fire action for hide rightbar
        dispatch(showRightSidebarAction(false));
      }
    },
    [dispatch]
  );

  useEffect(() => {
    //init body click event fot toggle rightbar
    document.body.addEventListener("click", hideRightbar, true);
  }, [hideRightbar]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    dispatch(changeLayout("vertical"));
  }, [dispatch]);

  useEffect(() => {
    if (leftSideBarTheme) {
      dispatch(changeSidebarTheme(leftSideBarTheme));
    }
  }, [leftSideBarTheme, dispatch]);

  useEffect(() => {
    if (layoutWidth) {
      dispatch(changeLayoutWidth(layoutWidth));
    }
  }, [layoutWidth, dispatch]);

  useEffect(() => {
    if (leftSideBarType) {
      dispatch(changeSidebarType(leftSideBarType));
    }
  }, [leftSideBarType, dispatch]);

  useEffect(() => {
    if (topbarTheme) {
      dispatch(changeTopbarTheme(topbarTheme));
    }
  }, [topbarTheme, dispatch]);

  return (
    <React.Fragment>
      <div id="layout-wrapper">
        <Header toggleMenuCallback={handleButtonClick} />
        <Sidebar theme={leftSideBarTheme} type={leftSideBarType} isMobile={isMobile} />
        <div className="main-content font-primary">{props.children}</div>
        {/* <Chat /> */}
        {/* {subscription_trialing && <TrialInfoBubble />} */}

        {user &&
          Intercom({
            app_id: "pmzc623d",
            user_id: user.$id, // IMPORTANT: Replace "user.id" with the variable you use to capture the user's ID
            name: user.name, // IMPORTANT: Replace "user.name" with the variable you use to capture the user's name
            email: user.email, // IMPORTANT: Replace "user.email" with the variable you use to capture the user's email
            created_at: user.$createdAt // IMPORTANT: Replace "user.createdAt" with the variable you use to capture the user's sign-up date in a Unix timestamp (in seconds) e.g. 1704067200
          })}
        {/* {window.location.pathname === "/mailbox" ? null : <Footer />} */}
      </div>
      {showRightSidebar ? <RightSidebar /> : null}
    </React.Fragment>
  );
};

Layout.propTypes = {
  changeLayoutWidth: PropTypes.func,
  changeSidebarTheme: PropTypes.func,
  changeSidebarType: PropTypes.func,
  changeTopbarTheme: PropTypes.func,
  children: PropTypes.object,
  layoutWidth: PropTypes.any,
  leftSideBarTheme: PropTypes.any,
  leftSideBarType: PropTypes.any,
  location: PropTypes.object,
  showRightSidebar: PropTypes.any,
  topbarTheme: PropTypes.any
};

export default withRouter(Layout);
